import { render, staticRenderFns } from "./ScannerHeader.vue?vue&type=template&id=bc63b87c&scoped=true"
import script from "./ScannerHeader.vue?vue&type=script&lang=js"
export * from "./ScannerHeader.vue?vue&type=script&lang=js"
import style0 from "./ScannerHeader.vue?vue&type=style&index=0&id=bc63b87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc63b87c",
  null
  
)

export default component.exports